export function popupBio() {
    $(".popup-opener").on("click", function (e) {
        $("body").addClass("popup-open");
        e.preventDefault();
    });

    $(".close-popup").on("click", function (e) {
        $("body").removeClass("popup-open");
        e.preventDefault();
    });

    $(document).keyup(function () {
        if (event.keyCode === 27) {
            $("body").removeClass("popup-open");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popupBio.js